import { GitBranch } from 'lucide-react';
import { Panel, Metric, Empty } from './Panel';

export const PipelineCard = ({ p }) => {
  const max = Math.max(1, ...p.stages.map((s) => p.by_stage[s] || 0));
  return (
    <Panel title="Pipeline at a glance" subtitle={`${p.active} active clients across onboarding`} icon={GitBranch}
      to="/ludo/pipeline" linkLabel="Open pipeline" testid="ludo-dash-pipeline">
      <div className="grid grid-cols-3 gap-3 mb-5">
        <Metric label="Active" value={p.active} testid="ludo-dash-active" />
        <Metric label="In care" value={p.in_care} tone="text-[#3C6152]" testid="ludo-dash-in-care" />
        <Metric label="Starts this month" value={p.starts_this_month} testid="ludo-dash-starts" />
      </div>
      <div className="space-y-2" data-testid="ludo-dash-stage-bars">
        {p.stages.map((s) => (
          <div key={s} className="flex items-center gap-3 text-[13px]" data-testid={`ludo-dash-stage-${s.replace(/\s+/g, '-').toLowerCase()}`}>
            <span className="w-32 shrink-0 text-[#6E5F78]">{s}</span>
            <div className="flex-1 h-2.5 rounded-full bg-[#F1EDF5] overflow-hidden">
              <div className="h-full rounded-full bg-[#5E5068] transition-[width] duration-700" style={{ width: `${(100 * (p.by_stage[s] || 0)) / max}%` }} />
            </div>
            <span className="w-8 text-right tabular-nums font-semibold text-[#2D2833]">{p.by_stage[s] || 0}</span>
          </div>
        ))}
        <div className="text-[11px] text-[#8A7B95] pt-1">
          {p.side_stages.map((s) => `${s}: ${p.by_stage[s] || 0}`).join(' · ')}
        </div>
      </div>
      <div className="mt-5 pt-4 border-t border-[#F1EDF5]">
        <div className="text-[11px] uppercase tracking-[0.12em] text-[#8A3A3A] font-semibold mb-2" data-testid="ludo-dash-stuck-count">
          Stuck {p.stuck_days}+ days · {p.stuck_count}
        </div>
        {p.stuck.length === 0 ? <Empty testid="ludo-dash-stuck-empty">Nobody is stuck — nice work.</Empty> : (
          <ul className="space-y-1.5">
            {p.stuck.map((c) => (
              <li key={c.client_id} className="flex justify-between text-[13px]" data-testid={`ludo-dash-stuck-${c.client_id}`}>
                <span className="text-[#2D2833]">{c.client_name} <span className="text-[#8A7B95]">· {c.stage}</span></span>
                <span className="tabular-nums text-[#8A3A3A] font-semibold">{c.days}d</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Panel>
  );
};

export default PipelineCard;
